import { render, staticRenderFns } from "./Collaborateur.vue?vue&type=template&id=11d347b2&"
import script from "./Collaborateur.vue?vue&type=script&lang=js&"
export * from "./Collaborateur.vue?vue&type=script&lang=js&"
import style0 from "./Collaborateur.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports